/*
 * @Author: YuanYuan
 * @Date: 2024-12-17 15:41:54
 * @LastEditTime: 2025-08-22 14:12:20
 * @Description: 用量查询接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'bandwidthDomains',
    path: `${prefix}/ddos/domain_port_data`,
    method: 'get',
    params: {
      packageId: '',
      startTime: '',
      endTime: '',
      groupId: ''
    },
    desc: '域名组和时间过滤下的域名'
  },
  {
    name: 'bandwidthQuery',
    path: `${prefix}/ddos/business_bandWidth_data`,
    method: 'get',
    params: {
      domain_list: '',
      port_list: '',
      package_id: '',
      begin_time: '',
      end_time: '',
      groupId: '',
      businessType: ''
    },
    desc: '请求带宽'
  },
  {
    name: 'reqDomains',
    path: `${prefix}/ddos/domain_data`,
    method: 'get',
    params: {
      startTime: '',
      endTime: '',
      groupId: '',
      packageId: ''
    },
    desc: '请求数域名条件'
  },
  {
    name: 'requestsQuery',
    path: `${prefix}/ddos/business_requestNum_data`,
    method: 'get',
    params: {
      requestNum_select: '',
      package_id: '',
      begin_time: '',
      end_time: '',
      groupId: ''
    },
    desc: '请求数'
  },
  {
    name: 'concurrentPorts',
    path: `${prefix}/ddos/port_data`,
    method: 'get',
    params: {
      packageId: ''
    },
    desc: '并发数端口号选项'
  },
  {
    name: 'concurrenciesQuery',
    path: `${prefix}/ddos/business_ContentNum_data`,
    method: 'get',
    params: {
      contentNum_select: '',
      package_id: '',
      begin_time: '',
      end_time: ''
    },
    desc: '并发数'
  }
]
